module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av746-ba8d2b8619d3ad526fde0c95d26b18f0.jpg";